import React from 'react';
import { Button, Card } from 'antd';

const ActionButtonsComponent = (props: { isOnEdit: boolean }) => {
  const onCancelEdition = () => {
    return window.cancelEdition()
  }

  const onSave = () => {
    return window.saveEdit()
  }

  return (
    <>
      {props.isOnEdit ? (
        <div
          className='action-buttons-bar'
          style={{ left: window.rightContentWidth }}>
          <div className='action-buttons-content'>
            <div className='actions-separator' />
            <Button onClick={onCancelEdition}>Cancel</Button>
            <Button type='primary' onClick={onSave}>
              Save
            </Button>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export default ActionButtonsComponent
